import React from "react";
import { Route, Navigate } from "react-router-dom";
import Dashboard from "../feature-module/dashboard/Dashboard";

const routes = all_routes;

import Chats from "../feature-module/Application/chat";
import Calendar from "../feature-module/Application/calendar";
import LowStock from "../feature-module/inventory/lowstock";
import EditProduct from "../feature-module/inventory/editproduct";
import Audiocall from "../feature-module/Application/audiocall";
import Callhistory from "../feature-module/Application/callhistory";
import ToDo from "../feature-module/Application/todo";
import Notes from "../feature-module/Application/notes";
import FileManager from "../feature-module/Application/filemanager";
import Profile from "../feature-module/pages/profile";
import Signin from "../feature-module/pages/login/signin";
import SigninTwo from "../feature-module/pages/login/signinTwo";
import SigninThree from "../feature-module/pages/login/signinThree";
import RegisterTwo from "../feature-module/pages/register/registerTwo";
import Register from "../feature-module/pages/register/register";
import RegisterThree from "../feature-module/pages/register/registerThree";
import Forgotpassword from "../feature-module/pages/forgotpassword/forgotpassword";
import ForgotpasswordTwo from "../feature-module/pages/forgotpassword/forgotpasswordTwo";
import ForgotpasswordThree from "../feature-module/pages/forgotpassword/forgotpasswordThree";
import Resetpassword from "../feature-module/pages/resetpassword/resetpassword";
import ResetpasswordTwo from "../feature-module/pages/resetpassword/resetpasswordTwo";
import ResetpasswordThree from "../feature-module/pages/resetpassword/resetpasswordThree";
import Lockscreen from "../feature-module/pages/lockscreen";
import Permissions from "../feature-module/usermanagement/permissions";
import ProductDetail from "../feature-module/inventory/productdetail";
import { all_routes } from "./all_routes";
import ExpenseForm from "../feature-module/pages/multistepform/ExpenseForm";
import ConfigurationMenu from "../feature-module/pages/configuration/configurationMenu";
import Menus from "../feature-module/pages/menus/menus";
import QrCodeList from "../feature-module/pages/qrcode/qrcode";
import ClientPreview from "../feature-module/pages/client/clientpreview";
import Homemenu from "../feature-module/pages/menus/homemenu";
import OrderSummary from "../feature-module/pages/order/order-summary";
import SpecificInstruction from "../feature-module/pages/order/specific-instruction";
import EndOrder from "../feature-module/pages/order/end-order";
import Restaurants from "../feature-module/pages/restaurants/restaurants";
import Cuisine from "../feature-module/pages/cuisine/cuisine";
import AccessCuisine from "../feature-module/pages/cuisine/access-cuisine";
import Statistics from "../feature-module/pages/Dashboard/statistics";
import RestoUsers from "../feature-module/pages/profilutilisateur/restousers";
import Historique from "../feature-module/pages/historique/historique";
import RawMaterial from "../feature-module/pages/matièrepremière/rawmaterial";
import Pricing from "../feature-module/pages/pricing/Pricing.jsx";
import Settings from "../feature-module/pages/settings/Settings.jsx";
import Categories from "../feature-module/pages/categories/Categories";
import ArticlesNew from "../feature-module/pages/cards/ArticlesNew.jsx";
import EtiquettesNew from "../feature-module/pages/etiquettes/EtiquettesNew";
import TablesNew from "../feature-module/pages/tables/TablesNew";
import CommandsNew from "../feature-module/pages/commandes/CommandsNew.jsx";
import Clients from "../feature-module/pages/tables/Clients";
import InventoryNew from "../feature-module/pages/ingredients/InventoryNew";
import Fournisseurs from "../feature-module/pages/fournisseurs/Fournisseurs";
import Depenses from "../feature-module/pages/depenses/Depenses"; //
import AccueilNew from "../feature-module/pages/accueil/AccueilNew";
import MesKpi from "../feature-module/pages/kpi/MesKpi";
import Marketplace from "../feature-module/pages/marketplace/Marketplace";

export const publicRoutes = [
  {
    id: 1,
    path: routes.dashboard,
    name: "home",
    element: <Dashboard />,
    route: Route,
  },
  {
    id: 2,
    path: routes.menus,
    name: "menus",
    element: <Menus />,
    route: Route,
  },
  {
    id: 3,
    path: routes.articles,
    name: "articles",
    element: <ArticlesNew />,
    route: Route,
  },
  {
    id: 4,
    path: routes.platcategory,
    name: "platcategory",
    element: <Categories />,
    route: Route,
  },

  {
    id: 6,
    path: routes.clientpreview,
    name: "clientpreview",
    element: <ClientPreview />,
    route: Route,
  },

  {
    id: 7,
    path: routes.chat,
    name: "chat",
    element: <Chats />,
    route: Route,
  },
  {
    id: 8,
    path: routes.lowstock,
    name: "lowstock",
    element: <LowStock />,
    route: Route,
  },
  {
    id: 9,
    path: routes.calendar,
    name: "calendar",
    element: <Calendar />,
    route: Route,
  },
  {
    id: 10,
    path: routes.editproduct,
    name: "editproduct",
    element: <EditProduct />,
    route: Route,
  },
  {
    id: 12,
    path: routes.audiocall,
    name: "audiocall",
    element: <Audiocall />,
    route: Route,
  },
  {
    id: 13,
    path: routes.callhistory,
    name: "callhistory",
    element: <Callhistory />,
    route: Route,
  },
  {
    id: 14,
    path: routes.todo,
    name: "todo",
    element: <ToDo />,
    route: Route,
  },
  {
    id: 15,
    path: routes.notes,
    name: "notes",
    element: <Notes />,
    route: Route,
  },
  {
    id: 16,
    path: routes.filemanager,
    name: "filemanager",
    element: <FileManager />,
    route: Route,
  },
  {
    id: 17,
    path: routes.profile,
    name: "profile",
    element: <Profile />,
    route: Route,
  },
  {
    id: 18,
    path: routes.permissions,
    name: "permissions",
    element: <Permissions />,
    route: Route,
  },
  {
    id: 20,
    path: routes.productdetails,
    name: "productdetails",
    element: <ProductDetail />,
    route: Route,
  },
  {
    id: 21,
    path: "*",
    name: "NotFound",
    element: <Navigate to="/" />,
    route: Route,
  },
  {
    id: 22,
    path: '/',
    name: 'Root',
    element: <Navigate to="/signin" />,
    route: Route,
  },
  {
    id: 23,
    path: routes.expenseForm,
    name: 'expenseform',
    element: <ExpenseForm />,
    route: Route,
  },
  {
    id: 24,
    path: routes.configuration,
    name: 'configurations',
    element: <ConfigurationMenu />,
    route: Route,
  },
  {
    id: 25,
    path: routes.Restaurants,
    name: 'Restaurants',
    element: <Restaurants />,
    route: Route,
  },
  {
    id: 26,
    path: routes.table,
    name: 'table',
    element: <TablesNew />,
    route: Route,
  },
  {
    id: 27,
    path: routes.commands,
    name: "commands",
    element: <CommandsNew />,
    route: Route,
  },
  {
    id: 29,
    path: routes.statistics,
    name: "statistics",
    element: <Statistics />,
    route: Route,
  },
  {
    id: 29,
    path: routes.accessCuisine,
    name: "accessCuisine",
    element: <AccessCuisine />,
    route: Route,
  },
  {
    id: 30,
    path: routes.etiquettes,
    name: "etiquettes",
    element: <EtiquettesNew />,
    route: Route,
  },
  {
    id: 31,
    path: routes.restoUsers,
    name: "restoUsers",
    element: <RestoUsers />,
    route: Route,
  },
  {
    id: 32,
    path: routes.historique,
    name: "historique",
    element: <Historique />,
    route: Route,
  },
  {
    id: 33,
    path: routes.rawMaterials,
    name: "rawMaterials",
    element: <RawMaterial />,
    route: Route,
  },
  {
    id: 34,
    path: routes.ingredients,
    name: "ingredients",
    element: <InventoryNew />,
    route: Route,
  },
  // {
  //   id: 35,
  //   path: routes.compositions,
  //   name: "compositions",
  //   element: <ArticleComposition />,
  //   route: Route,
  // }
  {
    id: 35,
    path: routes.pricing,
    name: "pricing",
    element: <Pricing />,
    route: Route,
  },
  {
    id: 36,
    path: routes.settings,
    name: "settings",
    element: <Settings />,
    route: Route,
  },
  {
    id: 37,
    path: routes.categorie,
    name: "categorie",
    element: <Categories />,
    route: Route,
  },
  {
    id: 38,
    path: routes.articlesNew,
    name: "articlesNew",
    element: <ArticlesNew />,
    route: Route,
  },
  {
    id: 39,
    path: routes.etiquettesNew,
    name: "etiquettesNew",
    element: <EtiquettesNew />,
    route: Route,
  },
  {
    id: 40,
    path: routes.tablesNew,
    name: "tablesNew",
    element: <TablesNew />,
    route: Route,
  },
  {
    id: 41,
    path: routes.commandsNew,
    name: "commandsNew",
    element: <CommandsNew />,
    route: Route,
  },
  {
    id: 42,
    path: routes.clients,
    name: "clients",
    element: <Clients />,
    route: Route,
  },
  {
    id: 43,
    path: routes.venteDistance,
    name: "venteDistance",
    element: <TablesNew />,
    route: Route,
  },
  {
    id: 44,
    path: routes.fournisseurs,
    name: 'fournisseurs',
    element: <Fournisseurs />,
    route: Route,
  },
  {
    id: 45,
    path: routes.achats,
    name: 'achats',
    element: <Depenses />,
    route: Route,
  },
  {
    id: 46,
    path: routes.accueil,
    name: 'accueil',
    element: <AccueilNew />,
    route: Route,
  },
  {
    id: 47,
    path: routes.mesKpi,
    name: 'mes-kpi',
    element: <MesKpi />,
    route: Route,
  },
  {
    id: 48,
    path: routes.marketplace,
    name: 'marketplace',
    element: <Marketplace />,
    route: Route,
  }
];

export const pagesRoute = [
  {
    id: 1,
    path: routes.signin,
    name: "signin",
    element: <Signin />,
    route: Route,
  },
  {
    id: 2,
    path: routes.signintwo,
    name: "signintwo",
    element: <SigninTwo />,
    route: Route,
  },
  {
    id: 28,
    path: routes.cuisine,
    name: "cuisine",
    element: <Cuisine />,
    route: Route,
  },
  {
    id: 3,
    path: routes.signinthree,
    name: "signinthree",
    element: <SigninThree />,
    route: Route,
  },
  {
    id: 4,
    path: routes.register,
    name: "register",
    element: <Register />,
    route: Route,
  },
  {
    id: 5,
    path: routes.registerTwo,
    name: "registerTwo",
    element: <RegisterTwo />,
    route: Route,
  },
  {
    id: 6,
    path: routes.registerThree,
    name: "registerThree",
    element: <RegisterThree />,
    route: Route,
  },
  {
    id: 7,
    path: routes.forgotPassword,
    name: "forgotPassword",
    element: <Forgotpassword />,
    route: Route,
  },
  {
    id: 8,
    path: routes.forgotPasswordTwo,
    name: "forgotPasswordTwo",
    element: <ForgotpasswordTwo />,
    route: Route,
  },
  {
    id: 9,
    path: routes.forgotPasswordThree,
    name: "forgotPasswordThree",
    element: <ForgotpasswordThree />,
    route: Route,
  },
  {
    id: 10,
    path: routes.resetpassword,
    name: "resetpassword",
    element: <Resetpassword />,
    route: Route,
  },
  {
    id: 11,
    path: routes.resetpasswordTwo,
    name: "resetpasswordTwo",
    element: <ResetpasswordTwo />,
    route: Route,
  },
  {
    id: 12,
    path: routes.resetpasswordThree,
    name: "resetpasswordThree",
    element: <ResetpasswordThree />,
    route: Route,
  },
  {
    id: 13,
    path: routes.lockscreen,
    name: "lockscreen",
    element: <Lockscreen />,
    route: Route,
  }
];

export const menuRoute = [
  {
    id: 5,
    path: routes.qrcodelist,
    name: "qrcodelist",
    element: <QrCodeList />,
    route: Route,
  },
  {
    id: 6,
    path: routes.ordersummary,
    name: "ordersummary",
    element: <OrderSummary />,
    route: Route,
  },
  {
    id: 7,
    path: routes.SpecificInstruction,
    name: "SpecificInstruction",
    element: <SpecificInstruction />,
    route: Route,
  },
  {
    id: 8,
    path: routes.endorder,
    name: "endorder",
    element: <EndOrder />,
    route: Route,
  },
  {
    id: 9,
    path: routes.homemenu,
    name: 'HomeMenu',
    element: <Homemenu />,
    route: Route,
  },
  {
    id: 10,
    path: routes.homeMenuPrefixed,
    name: 'HomeMenuPrefixed',
    element: <Homemenu />,
    route: Route,
  }
]
